import EnergyDashboard from './EnergyDashboard';

export default EnergyDashboard;
